import AdvancedSettingsDrawerActions from "./AdvancedSettingsDrawerActions";
import AdvancedSettingsDrawerMutations from "./AdvancedSettingsDrawerMutations";
import CustomDomain from "./customDomain/CustomDomainModule";
import Stratification from "./stratification/StratificationModule";
import AdvancedSettingsDrawerService from "../../../service/AdvancedSettingsDrawerService";

const state = { menu: AdvancedSettingsDrawerService.EmptyAdvancedSettingsDrawerMenuFactory(), };

const { actions } = AdvancedSettingsDrawerActions;

const { mutations } = AdvancedSettingsDrawerMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	mutations,
	modules: { CustomDomain, Stratification },
};
